// MCP servers write tool descriptions for a model, so they arrive with markdown
// ticks, model-facing <examples>/<hints> blocks, and lists collapsed into one line.
const TAG_BLOCK = /<([a-z][\w-]*)>[\s\S]*?<\/\1>/gi

export function formatToolDescription(raw: string | null | undefined): string {
	if (!raw) return ""
	return raw
		.replace(TAG_BLOCK, "")
		.replace(/`/g, "")
		.replace(/[ \t]+/g, " ")
		.replace(/ (?=\d+\. [A-Z(])/g, "\n")
		.replace(/ (?=- \w)/g, "\n")
		.split("\n")
		.map((line) => line.trim())
		.join("\n")
		.replace(/\n{3,}/g, "\n\n")
		.trim()
}
